import CustomCheckbox from '@/components/UI/Buttons/Checkbox/CustomCheckbox'
import styles from './MultiChoiceQuestion.module.css'
import { SurveyMultiChoiceQuestion } from "@/interfaces/survey_types"
import { useSurveyStore } from '@/stores/useSurveyStore'
import { useRef, useState } from 'react'

interface MultiChoiceQuestionProps extends React.ComponentProps<'div'> {
  data: SurveyMultiChoiceQuestion
}

export default function MultiChoiceQuestion ({ data, ...rest }: MultiChoiceQuestionProps) {
  const { setArrayField } = useSurveyStore()
  const [selected, setSelected] = useState<(string | number)[]>([])

  const fieldNameRef = useRef<string>(data['set-field'] ?? `multiChoiceField${crypto.randomUUID()}`)
  const fieldName: string = fieldNameRef.current

  function handleOnChange (checked: boolean, value: string | number) {    
    setSelected((prev) =>
      checked
        ? [...prev, value].sort()
        : prev.filter((item) => item !== value).sort()
    )

    if (data['set-field']) setArrayField(fieldName, value)
  }

  return(
    <div className={styles.optionsList} {...rest}>
      {data.choices.map((ch, i) => {
        if (!ch.value) return

        const id = `multiChoiceId${crypto.randomUUID()}`

        return (
          <div key={i} className={styles.checkboxWrapper}>
            <CustomCheckbox
              className={styles.checkbox}
              id={id}
              label={ch.name}
              value={ch.value}
              checked={selected.includes(ch.value)}
              onChange={handleOnChange}
            />
          </div>
        )
      })}
    </div>
  )
}